module.exports = __webpack_public_path__ + "img/Moni_normal.62634c1c.jpg";